import { useSearchParams } from 'react-router-dom';
import { FolderCard } from '~/components/FolderCard';
import { GridCard } from '~/components/media/card';
import type { ContentFolderCardProps__ContentFolder } from './ContentFolderCard.generated';
import { ContentMenu } from './ContentMenu';

/* GraphQL */ `#graphql
fragment ContentFolderCardProps__ContentFolder on ContentFolder {
  itemCount
  childrenCount
  id
  name
  updatedAt
  createdAt
}
`;

export interface ContentFolderCardProps {
  contentFolder: ContentFolderCardProps__ContentFolder;
}

export const ContentFolderCard = ({ contentFolder }: ContentFolderCardProps) => {
  const [searchParams] = useSearchParams();
  searchParams.set('page', '1');

  return (
    <GridCard>
      <FolderCard
        folder={contentFolder}
        to={{ pathname: `../${contentFolder.id}`, search: searchParams.toString() }}
        label="item"
      >
        <ContentMenu item={contentFolder} />
      </FolderCard>
    </GridCard>
  );
};
